<template>
  <div class="calc-page">
    <component :is="'tipps-segement'" :key="componentsKeyTipps"></component>
    <product-select-segment></product-select-segment>
    <component :is="'inputs-segment'" :key="componentsKeyInputs"></component>
    <component :is="'result-segment'" :key="componentsKeyResult"></component>
  </div>
</template>

<script>
import fn from '../../services/GlobalService'
import TippsSegment from '../segments/TippsSegment'
import ProductSelectSegment from '../segments/ProductSelectSegment'
import InputsSegment from '../segments/InputsSegment'
import ResultSegment from '../segments/ResultSegment'

export default {
  name: 'calc-page',
  components: {
    'tipps-segement': TippsSegment,
    'product-select-segment': ProductSelectSegment,
    'inputs-segment': InputsSegment,
    'result-segment': ResultSegment
  },
  computed: {

    /**
     * IMPORTANT:
     * This componentsKey changes each time when the user changes the calculation method
     * or the product. It forces the component to re-render, doing all that initialization
     * stuff! Without this re-rendering the different config files, which are loaded to
     * in the store, would have no effect on the interface elements.
     */
    componentsKeyTipps (component) {
      return this.$store.state.calc + '-' + this.$store.state.product + '-overlay'
    },
    componentsKeyInputs (component) {
      return this.$store.state.calc + '-' + this.$store.state.product + '-inputs'
    },
    componentsKeyResult (component) {
      return this.$store.state.calc + '-' + this.$store.state.product + '-result'
    }
  }
}
</script>

<style lang="sass">
</style>
